import { render } from "./TruncateRender.vue?vue&type=template&id=0c4400c6"
import script from "./TruncateRender.vue?vue&type=script&lang=js"
export * from "./TruncateRender.vue?vue&type=script&lang=js"

import "./TruncateRender.vue?vue&type=style&index=0&id=0c4400c6&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__